declare global {
    interface Window {
        maodou: any;
        webkit: any;
        WeixinJSBridge: any;
        gio: any;
        callbackMap: any;
        attendanceMap: any;
    }
    interface Document {
        attachEvent: any;
    }
    interface objMap {
        [key: number]: any;
        [key: string]: any;
    }
}

export const INTELLIGENT_DEVICES = ['xiaoai', 'xiaodu', 'tmall'];

export const isWXBrower = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    return /MicroMessenger/i.test(ua);
};

export const isAndroid = () => {
    const u = navigator.userAgent;
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
};

export const isIOS = () => {
    const u = navigator.userAgent;
    // return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    return !!u.match(/\((i|M)[^;]+;( U;)? (CPU|Intel).+Mac OS X/);
};

export const isPC = () => !(isAndroid() || isIOS());

export const isIPAD = () => {
    const re = /ipad/i;
    const u = navigator.userAgent;
    return re.test(u);
};

/**
 * 与APP交互的postMessage，通过type判断事件
 *
 * @param {fnName} string 与APP交互的方法名
 * @param {param} object 与APP交互的参数
 *
 */
export const sendMessageApp = (fnName: any, param?: any) => {
    try {
        if (isAndroid()) {
            if (fnName !== 'logNative') {
                console.log(
                    `调用安卓的端能力，方法：${fnName};参数：${
                        typeof param === 'object' ? JSON.stringify(param) : param
                    }`
                );
            }
            param
                ? window.maodou[fnName](typeof param === 'object' ? JSON.stringify(param) : param)
                : window.maodou[fnName]();
        }
        else if (isIOS()) {
            if (fnName !== 'logNative') {
                console.log(
                    `调用ios的端能力，方法：${fnName};参数：${
                        typeof param === 'object' ? JSON.stringify(param) : param
                    }`
                );
            }
            if (fnName === 'closeWebview') {
                setTimeout(() => {
                    location.href = 'https://feihua100.com/error';
                }, 1000);
            }
            window?.webkit?.messageHandlers[fnName]?.postMessage(
                typeof param === 'string' ? param : JSON.stringify(param)
            );
        }
    }
    catch (error: any) {
        // throw new Error(error);
    }
};

// gio上报
export const gioTrack = (eventName: string, eventSub?: any) => {
    sendMessageApp('growingIoReport', {eventName, eventSub});
};

// 微信支付api
export const applyWxPay = (item: any, callback: any) => {
    console.log(item);
    // 支付流程：https://pay.weixin.qq.com/wiki/doc/api/index.html
    //         https://pay.weixin.qq.com/wiki/doc/api/jsapi.php?chapter=7_3
    //     公众号/小程序：wxe02cd0bed85c4388
    // APP：wx903594676f4f48d9
    // 新app微信的key得换成这个
    // appsecretkey 019743d71dd8c769079cd6247d9cff9d
    function onBridgeReady() {
        console.log('进入调起支付');
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
                // 公众号名称，由商户传入
                appId: item ? item.appId : 'wxe02cd0bed85c4388',
                // wxe02cd0bed85c4388    process.env.payConfig.appId
                // 时间戳，自1970年以来的秒数
                timeStamp: item ? item.timeStamp : '1395712654',
                // 随机串
                nonceStr: item ? item.nonceStr : 'e61463f8efa94090b1f366cccfbbb444',
                package: item ? item.package : 'prepay_id=u802345jgfjsdfgsdg888',
                // 微信签名方式
                signType: item ? item.signType : 'MD5',
                // 微信签名
                paySign: item ? item.paySign : '70EA570631E4BB79628FBCA90534C63FF7FADD89',
            },
            (res: any) => {
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠.
                    callback && callback();
                    // 向后端轮询支付结果
                    console.log('微信返回支付成功');
                }
                else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                    // 用户取消支付
                    console.log('用户取消支付');
                }
                else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                    // 支付失败
                    console.log('微信返回支付失败');
                }
            }
        );
    }

    if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        }
        else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    }
    else {
        onBridgeReady();
    }
};

export const delWXparams = (url: string) => {
    let newUrl = url || location.href;
    if (/from=[^&$?]{1,}(&|$)/.test(location.search) || /isappinstalled=[^&$?]{1,}(&|$)/.test(location.search)) {
        const newSearch = location.search
            .replace(/from=[^&$?]{1,}(&|$)/, '')
            .replace(/isappinstalled=[^&$?]{1,}(&|$)/, '')
            .replace(/&$|\?$/, '');
        newUrl = location.origin + location.pathname + newSearch + location.hash;
    }
    return newUrl;
};

// 初始化微信分享
export const initWXShare = (obj: any, wxShare: Function) => {
    const newUrl: string = delWXparams(location.origin + obj.fullPath);
    const link: string = encodeURIComponent(newUrl);
    console.log('url=', link);

    const parms = {
        title: obj.title || '欢迎使用启蒙好课',
        desc: obj.desc || '孩子学了都喜欢~',
        link,
        imgUrl: obj.imgUrl || 'https://g.gsxcdn.com/feihua/20201215/ptQq_1608039151.png',
    };
    wxShare(parms, () => {
        console.log('微信分享调用成功……');
    });
};

// 获取随机数
export const getRandom = (minNum: any, maxNum: any) => parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);

/**
 * 更新缓存中的用户信息的属性值
 */
export const updateUserInfo = (key: string, val: any) => {
    console.log('进入更新缓存');
    const str: any = window.localStorage.getItem(`${window.location.host}userInfo`);
    const userInfo = JSON.parse(str);
    userInfo[key] = val;
    window.localStorage.setItem(`${window.location.host}userInfo`, JSON.stringify(userInfo));
};

/**
 * 获取缓存中的对象值
 * @param {*} item 缓存的对象
 * @returns
 */
export const getLocalStorageItem = (item: string) => {
    const infoStr = window.localStorage.getItem(item);
    return infoStr ? JSON.parse(infoStr) : null;
};

/**
 * 设置缓存中的对象值
 * @param {*} item 缓存的对象名称
 * @param {*} value 缓存的对象值
 * @returns
 */
export const setLocalStorageItem = (item: string, value: any) => {
    value && window.localStorage.setItem(item, JSON.stringify(value));
};

/**
 * 删除缓存中的对象值
 * @param {*} item 缓存的对象名称
 * @returns
 */
export const removeLocalStorageItem = (item: string) => {
    window.localStorage.removeItem(item);
};

/**
 * 节流函数
 * @param {*}
 * @returns
 */
export const throttle = (fn: any, delay: number) => {
    let last = new Date().getTime();
    let deferTimer: any = null;
    return function (...args: any) {
        const now = new Date().getTime();
        if (now < last + delay) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(() => {
                last = now;
                fn.apply(this, args);
            }, delay);
        }
        else {
            last = now;
            fn.apply(this, args);
        }
    };
};

/**
 * 版本比较
 */
export const compareVersion = (v1: string, v2: string) => {
    if (!v1 || !v2) {
        console.error('版本号值为空');
        return;
    }
    const a1: any = v1.split('.');
    const a2: any = v2.split('.');
    if (a1.length < 3 || a2.length < 3) {
        console.error('版本号应为三位');
        return;
    }
    return ((a1[0] - a2[0]) as any) || ((a1[1] - a2[1]) as any) || ((a1[2] - a2[2]) as any);
};

/**
 * 将日期改为 2021-07-02 的格式
 * @param str
 */
export const formatDate = (str: string) => {
    let [year, month, day] = str.split('-');

    month = Number(month) < 10 ? `0${month}` : month;
    day = Number(day) < 10 ? `0${day}` : day;

    return `${year}-${month}-${day}`;
};

/**
 * 补0逻辑
 * @param str
 */
export const addZero = (num: any) => (num < 10 ? `0${num}` : num.toString());

// 按照竖屏计算html的font-size
export const resetFontSize = () => {
    // html根元素
    const HTML_ELEMENT = document.documentElement;
    // 屏幕宽度
    let SCREEN_WIDTH = 0;
    // 标准fontSize计算值
    let BASE_FONT_SIZE = 0;
    // 处理后的fontSize计算值
    const REAL_BASE_FONT_SIZE = 0;
    console.log('竖屏状态！');
    SCREEN_WIDTH = HTML_ELEMENT.clientWidth;
    // 将屏幕分成10份，获取每一份宽度
    BASE_FONT_SIZE = SCREEN_WIDTH / 10;
    // 写入html元素fontSize
    // HTML_ELEMENT.style.fontSize = `${BASE_FONT_SIZE}px`;
    console.log(`打印根元素fontSize=${HTML_ELEMENT.style.fontSize}`);
};

export const setUrlQuery = (options: {url: string; query: any}) => {
    let {url, query} = options;
    if (!url) {
        return '';
    }
    if (query) {
        console.log('query', query);

        const queryArr = [];
        for (const key in query) {
            if (query.hasOwnProperty(key)) {
                queryArr.push(`${key}=${query[key]}`);
            }
        }
        if (url.indexOf('?') !== -1) {
            url = `${url}&${queryArr.join('&')}`;
        }
        else {
            url = `${url}?${queryArr.join('&')}`;
        }
    }
    return url;
};

/**
 * iOS 下通过端能力拉取课程 JSON，绕开 WKWebView 共享连接池"假活"导致的 TCP 超时。
 * 仅当 iOS 端 bridge 存在时走端能力；Android / 老版本 App / 失败 / 超时 一律 reject，
 * 由调用方回退到原有 axios 请求，保证不影响安卓与兜底。
 * @param {string} url 课程 JSON 地址(resourceH5)
 * @param {number} timeoutMs H5 侧等待端回调的超时，端内部自身也有超时+重试
 */
export const fetchCourseJsonViaNative = (url: string, timeoutMs = 6000): Promise<any> => {
    return new Promise((resolve, reject) => {
        const handler = (window as any)?.webkit?.messageHandlers?.fetchCourseJson;
        if (!handler) {
            // 安卓 / 老版本 iOS(无此 handler) → 直接回退
            reject(new Error('no native fetchCourseJson bridge'));
            return;
        }
        (window as any).callbackMap = (window as any).callbackMap || {};
        const cbName = `onCourseJson_${Date.now()}_${Math.floor(Math.random() * 1e6)}`;
        let done = false;
        const timer = setTimeout(() => {
            if (done) {
                return;
            }
            done = true;
            delete (window as any).callbackMap[cbName];
            reject(new Error('native fetchCourseJson timeout'));
        }, timeoutMs);
        (window as any).callbackMap[cbName] = (res: any) => {
            if (done) {
                return;
            }
            done = true;
            clearTimeout(timer);
            delete (window as any).callbackMap[cbName];
            try {
                if (res && res.success && res.data) {
                    resolve(typeof res.data === 'string' ? JSON.parse(res.data) : res.data);
                }
                else {
                    reject(new Error('native fetchCourseJson failed'));
                }
            }
            catch (e) {
                reject(e);
            }
        };
        sendMessageApp('fetchCourseJson', {url, callback: cbName});
    });
};

/**
 * 统一预热 gsxcdn 各子域连接(i./p./g./xiaozao)。首次访问某子域连接是冷/假活的(可卡 12~59s)，
 * 提前发一个极小 no-cors 请求把连接养热，使题目音频/图片/反馈音首次访问也快。成本极低(4个小请求)。
 */
export const warmGsxcdnConnections = () => {
    // speech-ws: 语音评测用户录音回放所在子域(自由表达题分数弹层后播放)
    ['i', 'p', 'g', 'xiaozao', 'speech-ws'].forEach(h => {
        try {
            fetch(`https://${h}.gsxcdn.com/favicon.ico?_warm=${Date.now()}`, {mode: 'no-cors', cache: 'no-store'}).catch(() => {});
        }
        catch (e) {}
    });
};

/**
 * 预加载本课即将用到的 CDN 资源到 WebView 共享缓存，同时预热各 gsxcdn 子域(i./p./g.)连接。
 * 解决"首次进入卡"：首次访问某子域连接是冷/假活的(曾卡 12~59s)，预热后首次也快。
 * 顺序：图片+音频(小)先并行(快速暖 p./g. 连接 + 缓存)；视频(大,moov在尾)随后顺序，调用方控制数量。
 * 资源 Cache-Control 多为 max-age=1年，可被后续页面命中。
 */
let _preloadEls: any[] = [];
export const preloadSessionResources = (opts: {images?: string[]; audios?: string[]; videos?: string[]}) => {
    const valid = (u: any) => typeof u === 'string' && /^https?:\/\//.test(u);
    // 清理上一次遗留的预加载元素
    _preloadEls.forEach(el => { try { el.src = ''; if (el.remove) { el.remove(); } } catch (e) {} });
    _preloadEls = [];

    // 1) 图片：暖 g. 连接 + 缓存
    (opts.images || []).filter(valid).forEach(url => {
        const img = new Image();
        img.src = url;
        _preloadEls.push(img);
    });
    // 2) 音频：暖 p. 连接 + 缓存(不播放)
    (opts.audios || []).filter(valid).forEach(url => {
        const a = document.createElement('audio');
        a.muted = true;
        a.preload = 'auto';
        a.src = url;
        _preloadEls.push(a);
    });
    // 3) 视频：顺序预加载(大文件;moov在尾,canplaythrough=整片下完进缓存,再下一个)
    const vids = (opts.videos || []).filter(valid);
    let i = 0;
    const nextVideo = () => {
        if (i >= vids.length) {
            return;
        }
        const url = vids[i++];
        const v = document.createElement('video');
        v.muted = true;
        v.preload = 'auto';
        (v as any).playsInline = true;
        v.style.cssText = 'position:absolute;width:0;height:0;opacity:0;pointer-events:none;';
        const done = () => {
            v.removeEventListener('canplaythrough', done);
            v.removeEventListener('error', done);
            try { v.src = ''; v.remove(); } catch (e) {}
            const idx = _preloadEls.indexOf(v);
            if (idx >= 0) { _preloadEls.splice(idx, 1); }
            nextVideo();
        };
        v.addEventListener('canplaythrough', done);
        v.addEventListener('error', done);
        v.src = url;
        document.body.appendChild(v);
        _preloadEls.push(v);
        v.load();
    };
    nextVideo();
};

/**
 * 调用端能力打印日志
 * @param {*} val
 * @returns
 */
export const logNative = (content: any) => {
    try {
        sendMessageApp('logNative', content);
    }
    catch (error) {
        // console.log(content);
    }
};

/**
 * @description 判断当前浏览器环境是否支持 WebP 格式
 * @param {string} [feature='lossless'] WebP 功能
 * @return {Promise<boolean>} 描述是否支持 WebP 格式的 Promise 对象
 */

export const isSupportWebP = (feature = 'lossless') => {
    const testImages = {
        lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
        lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
        alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
        animation:
            'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
    };

    return new Promise(resolve => {
        const _image = new Image();
        _image.onload = () => {
            const result = _image.width > 0 && _image.height > 0;
            resolve(result);
        };
        _image.onerror = () => {
            resolve(false);
        };
        // @ts-ignore
        _image.src = `data:image/webp;base64,${testImages[feature]}`;
    });
};

/**
 * 获取中文
 * @param num
 * @returns {*}
 */
export function sectionToChinese(section: number) {
    const chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
    const chnUnitChar = ['', '十', '百', '千'];

    const ori = section;
    let strIns = '';
    let chnStr = '';
    let unitPos = 0;
    let zero = true;
    while (section > 0) {
        const v = section % 10;
        if (v === 0) {
            if (!zero) {
                zero = true;
                chnStr = chnNumChar[v] + chnStr;
            }
        }
        else {
            zero = false;
            strIns = chnNumChar[v];
            strIns += chnUnitChar[unitPos];
            chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
    }
    if (ori < 20) {
        chnStr = chnStr.replace('一十', '十');
    }
    return chnStr;
}

/**
 * 数字转中文
 * @param num
 * @returns {*}
 */
export function numberToChanie(num: number) {
    const chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
    const chnUnitChar = ['', '十', '百', '千'];

    let unitPos = 0;
    let strIns = '';
    let chnStr = '';
    let needZero = false;

    if (num === 0) {
        return chnNumChar[0];
    }

    while (num > 0) {
        const section = num % 10000;
        if (needZero) {
            chnStr = chnNumChar[0] + chnStr;
        }
        strIns = sectionToChinese(section);
        strIns += section === 0 ? chnUnitSection[0] : chnUnitSection[unitPos];
        chnStr = strIns + chnStr;
        needZero = section < 1000 && section > 0;
        num = Math.floor(num / 10000);
        unitPos++;
    }
    return chnStr;
}
